module.exports = __webpack_public_path__ + "static/media/acesso-nao-autorizado.87ab7d4b.svg";